import _ from 'lodash'
import { Component } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { FeatureRefs } from '../cssFeatures.types'
import { StickyTopOffset } from './responsiveLayout.types'
import { hasResponsiveLayout } from '../../utils/hasResponsiveLayout'
import { createCssCompNode } from '../cssCompNode'

export const LANDING_PAGE_TOP_OFFSET = { '--top-offset': `0px` }
const DEFAULT_BREAKPOINT = 'default'

const generateCss = (isStickyHeader: boolean, headerHeight?: number) => ({
	'--top-offset': isStickyHeader ? 'var(--header-height)' : '0px',
	...(!!headerHeight && { '--header-height': `${headerHeight}px` }),
})

const getChildrenStickyTopOffset = (comp: Component, refs: FeatureRefs<'responsiveLayout'>) => {
	return (comp.components || []).map(refs.stickyTopOffset)
}

export const isRefComponent = (comp: Component): boolean => {
	return Boolean(comp.componentType === 'RefComponent' && comp.components?.length)
}

const isHeaderWrapper = (children: Array<StickyTopOffset>) => children?.includes(true)

export const stickyTopOffset = createCssCompNode('responsiveLayout', 'stickyTopOffset', {
	getDependencies: (component: Component, refs: FeatureRefs<'responsiveLayout'>) => {
		const componentViewMode = envRefs.componentViewMode

		if (hasResponsiveLayout(component)) {
			return {
				componentViewMode,
				refCompChildren: isRefComponent(component) ? getChildrenStickyTopOffset(component, refs) : null,
				breakpointsVariantsToLayouts: isRefComponent(component) ? refs.compLayouts(component) : null,
				isMeshV2: envRefs.experiment('specs.thunderbolt.mesh2'),
			}
		}

		if (component.componentType === 'HeaderContainer') {
			return {
				componentViewMode,
			}
		}

		return null
	},
	toViewItem: (component, data) => {
		// TODO: REMOVE 'data.isMeshV2' when hasResponsiveLayout supports mesh case
		if (!data || data.componentViewMode === 'editor' || data.isMeshV2) {
			return null
		}

		if (hasResponsiveLayout(component)) {
			if (component.componentType === 'HeaderSection') {
				return true
			}

			const { breakpointsVariantsToLayouts, refCompChildren } = data
			if (refCompChildren && isHeaderWrapper(refCompChildren) && breakpointsVariantsToLayouts) {
				return _.mapValues(breakpointsVariantsToLayouts, (variantsToLayouts) => {
					const layoutDataItems = _.flatten(Object.values(variantsToLayouts))
					const isStickyHeader = layoutDataItems.some(
						(layoutItem) => 'position' in layoutItem && layoutItem.position === 'sticky'
					)
					return generateCss(isStickyHeader)
				})
			}

			return null
		}

		const isStickyHeader = !!component.layout.fixedPosition
		const headerHeight = component.layout.height
		return { [DEFAULT_BREAKPOINT]: generateCss(isStickyHeader, headerHeight) }
	},
})
